import { useState } from "react";
import "./Sidebar.scss";
import { IoHomeOutline, IoLogOutOutline } from "react-icons/io5/index";
import { AiOutlineShop } from "react-icons/ai";
import { CgChevronDoubleDownR, CgChevronDoubleUpR } from "react-icons/cg";
import { AiOutlineShoppingCart } from 'react-icons/ai';
import { FaRegUser } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { Collapse } from "react-bootstrap";

const Sidebar = () => {
    const [open, setOpen] = useState(false);
    const location = useLocation();

    return (
        <div className={`sidebar sticky top-0 ${open ? 'isNotCollapse' : 'isCollapse'}`}>
            <div
                className={open ? 'sidebarLogo' : 'sidebarLogoCollapse'}
                // onClick={() => setOpen(!open)}
                aria-controls="collapse-area"
                aria-expanded={open}
            >
                <Link to="/">
                    <img src='https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/logo/LogoPink.png' alt="logo" />
                </Link>
                <div className={'logoIcon'} onClick={() => setOpen(!open)}>
                    {!open && <CgChevronDoubleDownR />}
                </div>
            </div>
            <Collapse in={open} className={`${''}`}>
                <div id="collapse-area position-relative">
                    <div className={`sidebarMenu ${!open ? 'backGroundColor' : ''}`}>
                        <Link to="/" className={`sidebarMenuItem ${location.pathname === '/home' || location.pathname === '/' ? 'active' : ''}`}><IoHomeOutline /></Link>
                        <Link to="/shop" className={`sidebarMenuItem  ${location.pathname === '/shop' ? 'active' : ''}`}> <AiOutlineShop /> </Link>
                        <Link to="/" className={'sidebarMenuItem'}><FaRegUser /></Link>
                        <Link to="/cart" className={`sidebarMenuItem  ${location.pathname === '/cart' ? 'active' : ''}`}><AiOutlineShoppingCart /></Link>
                        <Link to="/" className={'sideBarLogout'}><IoLogOutOutline /></Link>
                        <span className={'upArrowIcon sidebarMenuItem'} onClick={() => setOpen(!open)}><CgChevronDoubleUpR /></span>
                    </div>
                </div>
            </Collapse >
        </div >
    );
};

export default Sidebar;
